import {
  NEXT_STAGE,
  PREVIOUS_STAGE,
  TOTAL_STAGES,
  SUBMIT_FINAL,
  NEXT_BUTTON_UPDATE,
  SAVE_AND_EXIT_UPDATE,
  DETAILS_AVAILABLE_TO_PROCEED,
} from "../config/constants";
import { ContentMap } from "../config/contentMap";

const INITIAL_STATE = {
  currentStage: 0,
  isValidated: true,
  isSaveAndExit: false,
  isDetailsAvailableToProceed: true,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case NEXT_STAGE: {
      if (state.currentStage !== ContentMap.forms.length - 1) {
        return { ...state, currentStage: state.currentStage + 1 };
      } else {
        return { ...state };
      }
    }
    case PREVIOUS_STAGE: {
      if (state.currentStage > 0) {
        return { ...state, currentStage: state.currentStage - 1 };
      } else {
        return { ...state };
      }
    }
    case SUBMIT_FINAL: {
      return { ...state };
    }
    case NEXT_BUTTON_UPDATE: {
      return { ...state, isValidated: !payload };
    }
    case SAVE_AND_EXIT_UPDATE: {
      return { ...state, isSaveAndExit: payload };
    }
    case DETAILS_AVAILABLE_TO_PROCEED: {
      return { ...state, isDetailsAvailableToProceed: payload };
    }
    default:
      return state;
  }
};
